import React, { useEffect } from 'react';

import '.././App.css';

import IconHamburger from '../Images/Icons/icon_hamburger.svg';
import IconHome from '../Images/Icons/icon_home.svg';
import IconDev from '../Images/Icons/icon_dev.svg';
import Icon2D from '../Images/Icons/icon_2d.svg';
import Icon3D from '../Images/Icons/icon_3d.svg';
import IconAbout from '../Images/Icons/icon_about.svg';

function Header({
    changePage,
    isMainPage
}) {

    setTimeout(() => {
        const headerHeight = document.querySelector('.headerContainer').clientHeight;
        const icon = document.querySelector('.headerHamburgerIcon');        
        icon.style.top = ((headerHeight - icon.clientHeight) / 2) + 'px';

    }, 50);


    const removeShift = (iteration = 0) => {
        if(iteration < 10){
            const header = document.querySelector('.headerContainer')        
            if(header){
                header.classList.remove('shifted');
            }  
            else{
                setTimeout(() => {
                    removeShift(++iteration)
                }, 100);
            }
        }
    }
    
    useEffect(() => {
        if(!isMainPage){
            removeShift();
        }            
    })
    

    return (
        <div className={`headerContainer transparent shifted ${isMainPage ? 'mainPageHeader' : ''}`}>
            
            <div className="header">
                <div>
                    <h1>Dream</h1>
                    <h2>like a child</h2>
                </div>
                <div>
                    <h1>Work</h1>
                    <h2>hard</h2>
                </div>
                <div>
                    <h1>Create</h1>
                    <h2>masterpieces</h2>
                </div>      
            </div>  

            <div className="navigationContainer">
                <div className="navigation">
                    <div  onClick={() => changePage('main')}>
                        <span className="hidden-mobile" >Home</span>
                        <span className="visible-mobile" style={{fontSize: 'var(--fsize-s)'}}>
                            <img src={IconHome} alt='icon home'/>
                        </span>
                    </div>
                    
                    <span className='hidden-mobile'>|</span>

                    <div   onClick={() => changePage('dev')}>
                        <span className="hidden-mobile">Games {'&'} Apps</span> 
                        <span className="visible-mobile" style={{fontSize: '25px'}}>
                            <img src={IconDev} alt='icon development'/>
                        </span>                       
                    </div>
                    
                    <span className='hidden-mobile'>|</span>

                    <div  onClick={() => changePage('2d')}>
                        <span className="hidden-mobile" >2D Art</span> 
                        <span className="visible-mobile" style={{fontSize: 'var(--fsize-s)'}}>
                            <img src={Icon2D} alt='icon 2d art'/>
                        </span>                   
                    </div>
                    
                    <span className='hidden-mobile'>|</span>

                    <div  onClick={() => changePage('3d')}>
                        <span className="hidden-mobile" >3D Art</span>
                        <span className="visible-mobile" style={{fontSize: 'var(--fsize-s)'}}>
                            <img src={Icon3D} alt='icon 3d art'/>
                        </span>                        
                    </div>
                    
                    <span className='hidden-mobile'>|</span>

                    <div  onClick={() => changePage('about')}>
                        <span className="hidden-mobile" >About</span> 
                        <span className="visible-mobile" style={{fontSize: 'var(--fsize-s)'}}>
                            <img src={IconAbout} alt='icon about'/>
                        </span>                       
                    </div>   
                </div>                
            </div>
            
            <img src={IconHamburger} className="headerHamburgerIcon hidden-tablet" alt='icon hamburger menu'/>
        </div>
    );
    
}

export default Header;